import React from "react";

const PatientDetails = () => {
  return (
    <>
      <div className="h-100">
        <div className='border rounded-bottom rounded-5 border-top-0 border-start-0 border-end-0'>
          <h6 className='text-center p-10 fs-5'>Patient Details</h6>
        </div>
        <div className='card-body p-24'>
          <div className='d-flex flex-column gap-2'>
            <div className='d-flex align-items-center justify-content-between gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-36-px h-36-px rounded-circle d-flex justify-content-center align-items-center bg-lilac-100 flex-shrink-0'>
                  <img
                    src='assets/images/home-nine/socials1.png'
                    alt=''
                    className=' patient_detail_img'
                  />
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-semibold'>Center name</h6>
                </div>
              </div>
              <div className='d-flex align-items-center gap-8'>
                {/* <span className='text-secondary-light text-md fw-medium'>
                6,200
              </span> */}
                <span className='text-success-600 fs_small fw-medium'>SAAOL Delhi Jonapur</span>
              </div>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-36-px h-36-px rounded-circle d-flex justify-content-center align-items-center bg-warning-100 flex-shrink-0'>
                  {/* <img
                    src='assets/images/home-nine/socials2.png'
                    alt=''
                    className=' patient_detail_img'
                  /> */}
                  <i class="ri-id-card-line" style={{ color: "#ff9f29" }}></i>
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-semibold'>Date of Birth</h6>
                </div>
              </div>
              <div className='d-flex align-items-center gap-8'>
                {/* <span className='text-secondary-light text-md fw-medium'>
                Clicked
              </span> */}
                <span className='text-success-600 fs_small fw-medium'>2002-04-06</span>
              </div>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-36-px h-36-px rounded-circle d-flex justify-content-center align-items-center bg-info-100 flex-shrink-0'>
                  {/* <img
                    src='assets/images/home-nine/socials3.png'
                    alt=''
                    className=' patient_detail_img'
                  /> */}

                  <i class="ri-user-fill" style={{ color: "#144bd6" }}></i>
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-semibold'>Gender</h6>
                </div>
              </div>
              <div className='d-flex align-items-center gap-8'>
                {/* <span className='text-secondary-light text-md fw-medium'>
                5,175
              </span> */}
                <span className='text-success-600 fs_small fw-medium'>Male</span>
              </div>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-36-px h-36-px rounded-circle d-flex justify-content-center align-items-center bg-success-100 flex-shrink-0'>
                  {/* <img
                    src='assets/images/home-nine/socials4.png'
                    alt=''
                    className=' patient_detail_img'
                  /> */}
                  <i class="ri-map-pin-fill" style={{ color: "#45b369" }}></i>
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-semibold'>Address</h6>
                </div>
              </div>
              <div className='d-flex align-items-center gap-8'>
                {/* <span className='text-secondary-light text-md fw-medium'>
                3,780
              </span> */}
                <span className='text-success-600 fs_small fw-medium'>Delhi</span>
              </div>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-36-px h-36-px rounded-circle d-flex justify-content-center align-items-center bg-danger-100 flex-shrink-0'>
                  {/* <img
                    src='assets/images/home-nine/socials5.png'
                    alt=''
                    className=' patient_detail_img'
                  /> */}
                  <i class="ri-map-pin-range-line" style={{ color: '#ef4a00' }}></i>
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-semibold'>State</h6>
                </div>
              </div>
              <div className='d-flex align-items-center gap-8'>
                {/* <span className='text-secondary-light text-md fw-medium'>
                4,120
              </span> */}
                <span className='text-success-600 fs_small fw-medium'>Delhi</span>
              </div>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-36-px h-36-px rounded-circle d-flex justify-content-center align-items-center bg-info-100 flex-shrink-0'>
                  {/* <img
                    src='assets/images/home-nine/socials3.png'
                    alt=''
                    className=' patient_detail_img'
                  /> */}
                  <i class="ri-earth-fill text-cyan" ></i>
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-semibold'>Country</h6>
                </div>
              </div>
              <div className='d-flex align-items-center gap-8'>
                {/* <span className='text-secondary-light text-md fw-medium'>
                5,175
              </span> */}
                <span className='text-success-600 fs_small fw-medium'>India</span>
              </div>
            </div>
            <div className='d-flex align-items-center justify-content-between gap-3'>
              <div className='d-flex align-items-center gap-3'>
                <div className='w-36-px h-36-px rounded-circle d-flex justify-content-center align-items-center bg-info-100 flex-shrink-0'>
                  {/* <img
                    src='assets/images/home-nine/socials3.png'
                    alt=''
                    className=' patient_detail_img'
                  /> */}
                  <i class="ri-pushpin-fill" style={{ color: '#144bd6' }}></i>
                </div>
                <div className='flex-grow-1'>
                  <h6 className='text-md mb-0 fw-semibold'>Pin Code</h6>
                </div>
              </div>
              <div className='d-flex align-items-center gap-8'>
                {/* <span className='text-secondary-light text-md fw-medium'>
                5,175
              </span> */}
                <span className='text-success-600 fs_small fw-medium'>1111111</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default PatientDetails;
